import { render } from "./YourBetslip.vue?vue&type=template&id=7f8335ec&scoped=true"
import script from "./YourBetslip.vue?vue&type=script&lang=js"
export * from "./YourBetslip.vue?vue&type=script&lang=js"

import "@/assets/scss/ticket/yourBetslip.scss?vue&type=style&index=0&id=7f8335ec&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8335ec"]])

export default __exports__